import { render } from "./Employee_Biodata.vue?vue&type=template&id=5e9e5648"
import script from "./Employee_Biodata.vue?vue&type=script&lang=js"
export * from "./Employee_Biodata.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__